import React, {useEffect, useState} from 'react';
import {Navigate, Outlet, useLocation} from 'react-router-dom';
import {apiHost} from "../apiData";
import {getLanguage} from "../locales/langUtils";
import {AppSkeleton} from "./AppSkeleton";

export const PrivateRoutes = () => {
    const location = useLocation();
    const [isAuthorized, setIsAuthorized] = useState(false);
    const [redirectUrl, setRedirectUrl] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [serverDown, setIsServerDown] = useState(false);

    useEffect(() => {
        const authorizeRequest = async () => {
            setIsLoading(true);
            try {
                const response = await fetch(`${apiHost}/api/auth${location.pathname}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': getLanguage()
                    },
                    credentials: 'include'
                });
                await handleResponse(response);
            } catch {
                setIsAuthorized(false);
                setIsServerDown(true);
            } finally {
                setIsLoading(false);
            }
        }
        authorizeRequest();
    }, [location.pathname]);

    const handleResponse = async response => {
        if (response.ok) {
            setIsAuthorized(true);
        } else if (response.status === 302) {
            const body = await response.json();
            setRedirectUrl(body.redirectUrl);
        }
    }

    if (isLoading) {
        return (<AppSkeleton/>);
    } else if (redirectUrl) {
        window.location.href = redirectUrl;
        return;
    } else if (isAuthorized) {
        return (<Outlet/>);
    } else if (serverDown) {
        return (<Navigate to={"/server-down"}/>);
    }
    return (<Navigate to={"/sign-in"}/>);
};